export default "__VITE_ASSET__d1839011__"